/**
 * Pack metadata — Solo / Pro.
 * Pricing & quotas : voir CLAUDE.md racine (PIVOT 2026-05-04).
 *
 * Source de vérité : public.clients.metadata.pack ('solo' | 'pro').
 * Les listes d'agents par défaut sont des PLACEHOLDERS — Sebastian confirmera
 * la liste exacte avant le launch (cf scope original).
 */

export type Pack = 'solo' | 'pro';

export type PackInfo = {
  name: string;
  priceMonthly: number;
  agentsIncluded: number;
  apiQuotaMonthly: number;
  defaultAgents: string[];
  variant: 'solo' | 'pro';
};

export const PACK: Record<Pack, PackInfo> = {
  solo: {
    name: 'Solo',
    priceMonthly: 299,
    agentsIncluded: 3,
    apiQuotaMonthly: 5000,
    defaultAgents: ['A1', 'A2', 'A3'],
    variant: 'solo',
  },
  pro: {
    name: 'Pro',
    priceMonthly: 599,
    agentsIncluded: 6,
    apiQuotaMonthly: 15000,
    defaultAgents: ['A1', 'A2', 'A3', 'A6', 'A7', 'A8'],
    variant: 'pro',
  },
};

/** Agent metadata. Placeholder — final list confirmed by Sebastian pre-launch. */
export type AgentMeta = {
  id: string;
  name: string;
  description: string;
};

export const AGENTS: Record<string, AgentMeta> = {
  A1: { id: 'A1', name: 'Content Writer LinkedIn', description: 'Drafts posts dans ta voice, 5 par semaine.' },
  A2: { id: 'A2', name: 'Engagement Booster', description: 'Réponses aux commentaires, ton cohérent.' },
  A3: { id: 'A3', name: 'DM Outreach', description: 'Messages prospection 1-1, qualifiés.' },
  A4: { id: 'A4', name: 'Carousel Builder', description: 'Carousels pédagogiques 8 slides.' },
  A5: { id: 'A5', name: 'Lead Qualifier', description: 'Score chaque lead entrant 0-100.' },
  A6: { id: 'A6', name: 'Newsletter Curator', description: 'Hebdo récap pour ton audience.' },
  A7: { id: 'A7', name: 'Content Repurposer', description: 'Recycle un post en 3 formats.' },
  A8: { id: 'A8', name: 'Analytics Reporter', description: 'Rapport hebdo lisible, pas de jargon.' },
};

export function packFromString(value: unknown): Pack {
  return value === 'pro' ? 'pro' : 'solo';
}
